import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { useMediaQuery } from "react-responsive";
import { motion, AnimatePresence } from "framer-motion";
import { DirectionContext } from "../App";
import Cookies from "js-cookie";
import { useLocation } from "react-router-dom";

// 인스타그램 인앱 브라우저 감지 함수
const isInstagramInAppBrowser = () => {
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  const uaLower = ua.toLowerCase();
  return ua.indexOf("Instagram") > -1 || uaLower.indexOf("instagram") > -1;
};

const Onboarding = () => {
  const isDesktop = useMediaQuery({ minWidth: 768 });
  const { navigateTo } = useContext(DirectionContext);
  const location = useLocation();
  const [showInstagramModal, setShowInstagramModal] = useState(false);
  const [showToast, setShowToast] = useState(false);

  // 컴포넌트 마운트 시 모든 쿠키, 세션 스토리지, 로컬 스토리지 삭제 후 URL 파라미터 추출하여 쿠키 설정
  useEffect(() => {
    // 모든 쿠키 삭제
    const allCookies = Cookies.get();
    for (const cookieName in allCookies) {
      Cookies.remove(cookieName, { path: "/" });
    }

    // // 세션 스토리지 전체 삭제
    // sessionStorage.clear();

    // // 로컬 스토리지 전체 삭제
    // localStorage.clear();

    // URL에서 ref와 refDetail 파라미터 추출
    const searchParams = new URLSearchParams(location.search);
    const ref = searchParams.get("ref");
    const refDetail = searchParams.get("refDetail");
    const joint = searchParams.get("joint");

    if (ref && refDetail) {
      // 추출한 값을 쿠키에 저장 (7일 유효기간)
      Cookies.set("referralSource", ref, { expires: 7, path: "/" });
      Cookies.set("referralDetail", refDetail, { expires: 7, path: "/" });
    }

    // joint 파라미터가 true이면 쿠키에 저장
    if (joint === "true") {
      Cookies.set("joint", "true", { expires: 7, path: "/" });
    }
  }, [location]);

  const handleOnboardingComplete = () => {
    // 인스타그램 인앱 브라우저인 경우 모달 표시
    if (isInstagramInAppBrowser()) {
      setShowInstagramModal(true);
      return;
    }
    navigateTo("/select");
  };

  const handleCopyLink = () => {
    const currentUrl = "https://www.lawfirmthe-h-coupang.info/";

    // 모바일 지원을 위한 fallback 복사 방법 추가
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(currentUrl)
        .then(() => {
          showCopySuccess();
        })
        .catch((err) => {
          fallbackCopy(currentUrl);
        });
    } else {
      fallbackCopy(currentUrl);
    }
  };

  // 폴백 복사 메소드 (모바일 지원을 위해)
  const fallbackCopy = (text) => {
    // 임시 텍스트 영역 생성
    const textArea = document.createElement("textarea");
    textArea.value = text;

    // 화면 밖으로 위치시키기
    textArea.style.position = "fixed";
    textArea.style.left = "-999999px";
    textArea.style.top = "-999999px";
    document.body.appendChild(textArea);

    // 선택 및 복사
    textArea.focus();
    textArea.select();

    let success = false;
    try {
      success = document.execCommand("copy");
    } catch (err) {}

    // 정리
    document.body.removeChild(textArea);

    // 성공 표시
    if (success) {
      showCopySuccess();
    }
  };

  // 복사 성공 표시
  const showCopySuccess = () => {
    setShowToast(true);

    // 2초 후 표시 제거
    setTimeout(() => {
      setShowToast(false);
    }, 2000);
  };

  return (
    <PageBackground>
      <Container
        variants={pageVariants}
        initial="initial"
        animate="in"
        exit="out"
      >
        <BackgroundImage
          src="/png/bg.png"
          alt="배경"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
        />
        <Overlay />
        <Content variants={contentVariants} initial="initial" animate="in">
          <TextSection variants={textVariants}>
            {/* <MainTitle variants={textVariants}>
              SKT 유심 개인정보 유출 사고
              <br />
              집단소송 접수
            </MainTitle>
            <SubTitle variants={textVariants}>
              복잡한 절차 없이, 온라인으로 접수하세요
            </SubTitle> */}
          </TextSection>

          <ActionButtonWrapper>
            <ActionButton onClick={handleOnboardingComplete}>
              소송 접수하기
              <ArrowIcon src="/png/arrowWhite.png" alt="화살표" />
            </ActionButton>
          </ActionButtonWrapper>
        </Content>
      </Container>

      {/* 인스타그램 인앱 브라우저 모달 */}
      <AnimatePresence>
        {showInstagramModal && (
          <InstagramModalOverlay
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <InstagramModalHeader>
              <InstagramHeaderText>
                상단 메뉴를 통해 이동하거나,
                <br />
                링크 복사를 눌러주세요.
              </InstagramHeaderText>
              <InstagramIcon src="/png/InstargramIcon.png" alt="인스타그램" />
            </InstagramModalHeader>
            <InstagramModalContainer
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 50 }}
              transition={{ duration: 0.3 }}
            >
              <InstagramModalContent>
                <InstagramModalImage
                  src="/png/InstagramModal.png"
                  alt="인스타그램 모달 안내"
                />
                <InstagramButtonContainer>
                  <InstagramButtonImage
                    src="/png/instaButton.png"
                    alt="주소 링크 복사하기"
                    onClick={handleCopyLink}
                  />
                  <InstagramModalNote>
                    복사 후 주소창에 붙여넣으시면 바로 연결됩니다.
                  </InstagramModalNote>
                </InstagramButtonContainer>
              </InstagramModalContent>
            </InstagramModalContainer>

            {/* 토스트 알림 */}
            <AnimatePresence>
              {showToast && (
                <InstagramToast
                  variants={toastVariants}
                  initial="initial"
                  animate="animate"
                  exit="exit"
                >
                  <InstagramCheckIcon>✓</InstagramCheckIcon>
                  링크가 클립보드에 복사되었습니다
                </InstagramToast>
              )}
            </AnimatePresence>
          </InstagramModalOverlay>
        )}
      </AnimatePresence>
    </PageBackground>
  );
};

// 애니메이션 변수
const pageVariants = {
  initial: {
    opacity: 0,
  },
  in: {
    opacity: 1,
    transition: {
      duration: 0.5,
    },
  },
  out: {
    opacity: 0,
    transition: {
      duration: 0.3,
    },
  },
};

// 토스트 애니메이션
const toastVariants = {
  initial: { opacity: 0, y: 50 },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      type: "spring",
      stiffness: 300,
      damping: 20,
    },
  },
  exit: {
    opacity: 0,
    y: 50,
    transition: {
      duration: 0.3,
    },
  },
};

const contentVariants = {
  initial: {
    opacity: 0,
    y: 20,
  },
  in: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      delay: 0.2,
      staggerChildren: 0.1,
    },
  },
};

const textVariants = {
  initial: {
    opacity: 0,
    y: 10,
  },
  in: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.4,
      staggerChildren: 0.1,
    },
  },
};

// 스타일 컴포넌트
const PageBackground = styled.div`
  width: 100%;
  min-height: 100vh;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;

  @media (min-width: 769px) {
    padding: 20px;
  }
`;

const Container = styled(motion.div)`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  /* 모바일 디바이스 */
  @media (max-width: 768px) {
    min-height: 100vh;
    box-shadow: none;
    background-color: transparent;
    padding: 0;
    max-width: 100%;
    margin: 0;
    border-radius: 0;
  }

  /* 데스크탑 디바이스 */
  @media (min-width: 768px) {
    background-color: #f8fafc;
    border-radius: 20px;
    height: 700px;
    min-height: 700px;
    max-width: 470px;
    margin: 0 auto;

    box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
    padding: 20px;
  }
`;

const BackgroundImage = styled(motion.img)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;

  @media (min-width: 769px) {
    border-radius: 20px;
  }
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 1;

  @media (min-width: 769px) {
    border-radius: 20px;
  }
`;

const Content = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: left;
  z-index: 2;
  width: 100%;
  height: 90%;
  position: relative;

  @media (max-width: 768px) {
    padding: 0 20px;
    min-height: 100vh;
  }

  @media (min-width: 769px) {
    min-height: 700px;
    padding: 60px 20px;
  }
`;

const TextSection = styled(motion.div)`
  margin-top: 120px;
  color: white;
  z-index: 2;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);

  @media (min-width: 769px) {
    margin-top: 80px;
  }
`;

const MainTitle = styled(motion.h1)`
  font-size: 28px;
  font-weight: 700;
  line-height: 1.3;
  margin-bottom: 10px;
  word-break: keep-all;
  color: white;
`;

const SubTitle = styled(motion.p)`
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  word-break: keep-all;
  opacity: 0.9;
  color: white;
`;

const ActionButtonWrapper = styled.div`
  position: absolute;
  bottom: 62%;
  left: 25%;
  transform: translateX(-50%);
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
  box-sizing: border-box;

  @media (min-width: 769px) {
    bottom: 15%;
    left: 50%;
    transform: translateX(-50%);
  }
`;

const ActionButton = styled(motion.button)`
  display: flex;
  width: 145px;
  padding: 8px 0px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 5px;
  border-radius: 40px;
  background: #3855e2;
  border: none;
  color: white;
  font-family:
    Pretendard,
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    Oxygen,
    Ubuntu,
    Cantarell,
    "Open Sans",
    "Helvetica Neue",
    sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 160%;
  cursor: pointer;
`;

const ArrowIcon = styled.img`
  margin-left: 5px;
  width: 16px;
  height: 16px;
  object-fit: contain;
`;

// 인스타그램 인앱 브라우저 모달 스타일 컴포넌트
const InstagramModalOverlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(19, 19, 19, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  touch-action: none;
  pointer-events: auto;
  padding: 20px;
`;

const InstagramModalHeader = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  gap: 6px;
  z-index: 100000;
  pointer-events: none;
`;

const InstagramHeaderText = styled.div`
  font-size: 12px;
  color: white;
  line-height: 1.4;
  text-align: right;
  white-space: nowrap;
`;

const InstagramIcon = styled.img`
  width: 20px;
  height: 20px;
  object-fit: contain;
`;

const InstagramModalContainer = styled(motion.div)`
  position: relative;
  width: 100%;
  max-width: 400px;
  background-color: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  pointer-events: auto;
`;

const InstagramModalContent = styled.div`
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
`;

const InstagramModalImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
  object-fit: contain;
  padding: 24px 24px 0 24px;
  box-sizing: border-box;
`;

const InstagramButtonImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
  object-fit: contain;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }

  &:active {
    opacity: 0.8;
  }
`;

const InstagramButtonContainer = styled.div`
  padding: 24px;
  width: 100%;
  box-sizing: border-box;
`;

const InstagramModalTitle = styled.h2`
  font-size: 20px;
  font-weight: 700;
  color: #333;
  margin: 0 0 16px 0;
  line-height: 1.4;
`;

const InstagramModalText = styled.p`
  font-size: 15px;
  color: #666;
  margin: 0 0 24px 0;
  line-height: 1.6;
  word-break: keep-all;
`;

const InstagramModalSteps = styled.div`
  width: 100%;
  margin: 0 0 24px 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const InstagramStepItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  text-align: left;
`;

const InstagramStepNumber = styled.div`
  min-width: 28px;
  height: 28px;
  background-color: #0075ff;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  flex-shrink: 0;
`;

const InstagramStepText = styled.div`
  font-size: 15px;
  color: #333;
  line-height: 1.6;
  flex: 1;
  padding-top: 2px;
  display: flex;
  align-items: center;
  gap: 8px;

  strong {
    color: #0075ff;
    font-weight: 600;
  }
`;

const InstagramExternalIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

const InstagramCopyButton = styled.button`
  width: 100%;
  padding: 14px 20px;
  background-color: #0075ff;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 12px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #0056d6;
  }

  &:active {
    background-color: #0044b3;
  }
`;

const InstagramLinkIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

const InstagramModalNote = styled.div`
  margin-top: 10px;
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  width: 100%;
  box-sizing: border-box;
`;

// 토스트 알림 스타일
const InstagramToast = styled(motion.div)`
  position: fixed;
  bottom: 40px;
  left: 17%;
  transform: translateX(-50%);
  background-color: rgba(46, 56, 64, 0.9);
  color: white;
  padding: 12px 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  font-size: 14px;
  z-index: 100001;
  min-width: 200px;
  max-width: 90%;

  @media (min-width: 768px) {
    max-width: 400px;
  }
  @media (min-width: 769px) {
    left: 41.5%;
  }
`;

const InstagramCheckIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background-color: #0075ff;
  color: white;
  border-radius: 50%;
  margin-right: 8px;
  font-size: 16px;
  font-weight: bold;
`;

export default Onboarding;
